import { Component, OnInit, OnDestroy } from '@angular/core';
import { Alert, AlertConfiguration } from '../../alert';
import { DataManagementService } from '../../../data-management/data-management.service';
import { ToastrService } from 'ngx-toastr';
import { AlertManagementService } from '../../alert-management.service';
import { Subscription } from 'rxjs/Rx';

@Component({
  selector: 'app-document-settings',
  templateUrl: './document-settings.component.html',
  styleUrls: ['./document-settings.component.css']
})
export class DocumentSettingsComponent implements OnInit, OnDestroy {
  public alert: Alert = new Alert();
  public value1 = 10;
  public getVehiculeWasSelectedSubscription: Subscription;

  public insuranceAlertConfiguration: AlertConfiguration = new AlertConfiguration();
  public visiteAlertConfiguration: AlertConfiguration = new AlertConfiguration();
  public roadTaxesAlertConfiguration: AlertConfiguration = new AlertConfiguration();
  public operationalCertificationAlertConfiguration: AlertConfiguration = new AlertConfiguration();
  public permitCertificationAlertConfiguration: AlertConfiguration = new AlertConfiguration();
  public loader = false;
  public showAdvancedSettings = true;
  public enableGlobalConfig = false;
  public enableGlobalConfigToAllVehicules = false;

  public days: string[] = [];

  constructor(
    private toastr: ToastrService,
    public alertManagementService: AlertManagementService,
    private dataManagementService: DataManagementService
  ) {
    this.alertManagementService.initDays();
  }

  ngOnInit() {
    if (this.dataManagementService.selectedVehicule) {
      this.loadAlertConfigOfDevice(
        this.dataManagementService.selectedVehicule.idDevice
      );
    }

    this.getVehiculeWasSelectedSubscription = this.dataManagementService
      .getVehiculeWasSelected()
      .subscribe(vehicule => {
        this.loadAlertConfigOfDevice(
          this.dataManagementService.selectedVehicule.idDevice
        );
      });
  }

  ngOnDestroy() {
    if (this.getVehiculeWasSelectedSubscription) {
      this.getVehiculeWasSelectedSubscription.unsubscribe();
    }
  }

  loadAlertConfigOfDevice(device: number) {
    this.loader = true;
    this.alertManagementService
      .getAlertByNameAndDeviceId('DOC', device)
      .subscribe(
        alert => {
          this.alert = alert;
          this.insuranceAlertConfiguration = this.alert.alertConfigurations.filter(
            alertConfiguration => alertConfiguration.type === 'INSURANCE'
          )
            ? this.alert.alertConfigurations.filter(
              alertConfiguration => alertConfiguration.type === 'INSURANCE'
            )[0]
            : this.insuranceAlertConfiguration;
          this.visiteAlertConfiguration = this.alert.alertConfigurations.filter(
            alertConfiguration => alertConfiguration.type === 'VISIT'
          )
            ? this.alert.alertConfigurations.filter(
              alertConfiguration => alertConfiguration.type === 'VISIT'
            )[0]
            : this.visiteAlertConfiguration;
          this.roadTaxesAlertConfiguration = this.alert.alertConfigurations.filter(
            alertConfiguration => alertConfiguration.type === 'ROAD_TAXES'
          )
            ? alert.alertConfigurations.filter(
              alertConfiguration => alertConfiguration.type === 'ROAD_TAXES'
            )[0]
            : this.roadTaxesAlertConfiguration;
          this.operationalCertificationAlertConfiguration = this.alert.alertConfigurations.filter(
            alertConfiguration =>
              alertConfiguration.type === 'OPERATIONAL_CERTIFICATION'
          )
            ? this.alert.alertConfigurations.filter(
              alertConfiguration =>
                alertConfiguration.type === 'OPERATIONAL_CERTIFICATION'
            )[0]
            : this.operationalCertificationAlertConfiguration;
          this.permitCertificationAlertConfiguration = this.alert.alertConfigurations.filter(
            alertConfiguration =>
              alertConfiguration.type === 'PERMIT_CIRCULATION'
          )
            ? this.alert.alertConfigurations.filter(
              alertConfiguration =>
                alertConfiguration.type === 'PERMIT_CIRCULATION'
            )[0]
            : this.permitCertificationAlertConfiguration;

          this.loader = false;
          this.toastr.success('Configuration chargée', 'info !', {
            timeOut: 1000
          });
        },
        () => {
          this.loader = false;
          this.toastr.error('Configuration non chargée', 'info !', {
            timeOut: 1000
          });
        }
      );
  }

  emailSettings(emailsSettings: { emailMode: boolean; emails: string; enableGlobalConfig: boolean, enableGlobalConfigToAllVehicules: boolean  }) {
    this.alert.emailMode = emailsSettings.emailMode;
    this.alert.emails = emailsSettings.emails;
    this.enableGlobalConfig = emailsSettings.enableGlobalConfig;
    this.enableGlobalConfigToAllVehicules = emailsSettings.enableGlobalConfigToAllVehicules;
    if (emailsSettings.enableGlobalConfig || emailsSettings.enableGlobalConfigToAllVehicules) {
      this.updateEmails();
    }
  }

  save() {
    // Valider avant d'enregistrer
    if (!this.validateInputs()) {
      return;
    }
    this.loader = true;
    this.alert.enableGlobalConfig = this.enableGlobalConfig;
      this.alert.alertConfigurations = [
        this.insuranceAlertConfiguration,
        this.visiteAlertConfiguration,
        this.roadTaxesAlertConfiguration,
        this.operationalCertificationAlertConfiguration,
        this.permitCertificationAlertConfiguration
      ];
   if (!this.showAdvancedSettings) {
     this.alertManagementService.initializeAlertConfigurationWithSameValue1(
       this.value1,
       this.alert.alertConfigurations
     );
   }
    this.alertManagementService.updateAlert(this.alert).subscribe(
      alert => {
        this.alert = alert;
        this.toastr.success('Configuration enregistrée', 'info !');
        this.loader = false;
      },
      error => {
        this.toastr.error('Configurations non enregistrée', 'info !');
      }
    );
  }

  initDays() {
    for (var i = 1; i <= 90; i++) {
      this.days.push(i + '');
    }
  }

  test(config: AlertConfiguration, value: any) {
    config.value1 = value;
  }

  collapseAdvancedSettings() {
    this.showAdvancedSettings = !this.showAdvancedSettings;
  }
  updateEmails() {
    let id = 0;
    if (this.enableGlobalConfig || this.enableGlobalConfigToAllVehicules) {
      id = this.alert.deviceId;
    } else {
      id = this.alert.id;
    }
    this.alertManagementService.setEmailToAllAlert(this.alert.emails, id, this.enableGlobalConfig, this.enableGlobalConfigToAllVehicules)
      .subscribe(res => {
        if (res) {
          this.toastr.success('emails bien copiés ');
        } else {
          this.toastr.warning('Veuillez reverifier');
        }
      }
      )
  }


  applyValueToAllConfigurations() {
    // Récupérer la valeur actuelle
    let currentValue = this.value1;

    // Si la valeur est vide ou espace, ne rien faire (sera géré par onValue1Blur)
    if (currentValue === null || currentValue === undefined ||currentValue.toString().trim() === '') {
      return;
    }

    // Convertir en nombre
    let numValue = Number(currentValue);

    // Si ce n'est pas un nombre valide, ne rien faire
    if (isNaN(numValue)) {
      return;
    }

    // Limiter entre 1 et 365
    if (numValue < 1) {
      numValue = 1;
      this.value1 = numValue;
    }
    if (numValue > 365) {
      numValue = 365;
      this.value1 = numValue;
    }

    // Appliquer la valeur à toutes les configurations actives
    if (this.insuranceAlertConfiguration.isActive) {
      this.insuranceAlertConfiguration.value1 = numValue;
    }
    if (this.visiteAlertConfiguration.isActive) {
      this.visiteAlertConfiguration.value1 = numValue;
    }
    if (this.operationalCertificationAlertConfiguration.isActive) {
      this.operationalCertificationAlertConfiguration.value1 = numValue;
    }
    if (this.permitCertificationAlertConfiguration.isActive) {
      this.permitCertificationAlertConfiguration.value1 = numValue;
    }
    if (this.roadTaxesAlertConfiguration.isActive) {
      this.roadTaxesAlertConfiguration.value1 = numValue;
    }
  }
  preventEnterSubmit(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  }



  validateInputs(): boolean {
    // Vérifier le champ principal - accepter qu'il soit vide
    if (this.value1 !== null && this.value1 !== undefined&& isNaN(Number(this.value1))) {
      this.toastr.error('Le nombre de jours doit être un nombre valide', 'Erreur');
      return false;
    }

    // Si le champ principal n'est pas vide, vérifier les limites
    if (this.value1 !== null && this.value1 !== undefined ) {
      let numValue = Number(this.value1);
      if (numValue < 1 || numValue > 365) {
        this.toastr.error('Le nombre de jours doit être entre 1 et 365', 'Erreur');
        return false;
      }
    }

    // Vérifier les configurations actives
    const configs = [
      { config: this.insuranceAlertConfiguration, name: 'Assurance' },
      { config: this.visiteAlertConfiguration, name: 'Visite' },
      { config: this.operationalCertificationAlertConfiguration, name: 'Certification exploitation' },
      { config: this.permitCertificationAlertConfiguration, name: 'Permis Circulation' },
      { config: this.roadTaxesAlertConfiguration, name: 'Vignette' }
    ];

    for (let item of configs) {
      if (item.config.isActive && (!item.config.value1 || item.config.value1 === null || isNaN(Number(item.config.value1)))) {
        this.toastr.error(`${item.name} : veuillez saisir un nombre de jours`, 'Erreur');
        return false;
      }
    }

    return true;
  }

  onValue1Blur() {
    // Quand on quitte le champ, si vide ou espace, mettre 10
    if (this.value1 === null || this.value1 === undefined || this.value1.toString().trim() === '') {
      this.value1 = 10;
      this.applyValueToAllConfigurations();
    }
  }
}
